module.exports = __webpack_public_path__ + "static/media/kfc.65e0cfd4.svg";